import styled from '@emotion/styled'

import { ApiAssetPriceWithOverride } from '../../../api/_legacy/generated-api'
import { Column, ResultTable, Space } from '../../../components/core-v2'

type OverrideList = {
  dataSource: string
  price: string
  valueDate: string
}

type OverrideProps = {
  currency: string
  priceHistory: ApiAssetPriceWithOverride[]
}

const StyledWrapper = styled.div`
  table {
    th {
      background: var(--White);
      &:last-of-type {
        text-align: right;
      }
    }
    td {
      padding: 16px 8px;
      border-left: none;
      border-top: none;
      &:last-of-type {
        text-align: right;
      }
    }
  }
`

export const OverridesTab = ({ currency, priceHistory }: OverrideProps) => {
  const overrides: OverrideList[] = []
  const filteredPrices = priceHistory.filter(x => x.isManuallyOverridden)
  filteredPrices.forEach(x => {
    const valDate = new Date(x.valueDate)
    overrides.push({
      price: `${currency} ${x.price.toFixed(2)}`,
      dataSource: x.source,
      valueDate: valDate.toDateString()
    })
  })

  const columns: Column<OverrideList>[] = [
    {
      name: 'price',
      title: 'Name'
    },
    {
      name: 'dataSource',
      title: 'Source'
    },
    {
      name: 'valueDate',
      title: 'Value date'
    }
  ]

  return (
    <Space mx={5} py={6}>
      <StyledWrapper>
        <ResultTable columns={columns} data={overrides} />
      </StyledWrapper>
    </Space>
  )
}
